module.exports = __webpack_public_path__ + "img/offline.7cdbae9f.svg";